import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import Activity from '@app/components/Activity/Activity'
import { withAccessDenied, withNotifications, withProgressAndErrorMessage } from '@app/hocs'

let enhance = Activity

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { activities } = state.activities.activities
  return {
    activities,
    isMobile,
    accessToken: state.secrets.accessToken && state.secrets.accessToken.token,
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = withProgressAndErrorMessage(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const ActivityEnhanced = enhance

export default ActivityEnhanced
